import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const RETURN_ROUTE_KEY = 'adminRouteBeforeOffline';

const ConnectivityRedirect = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const redirectOffline = () => {
            if (location.pathname !== '/offline') {
                sessionStorage.setItem(RETURN_ROUTE_KEY, `${location.pathname}${location.search}${location.hash}`);
                navigate('/offline', { replace: true });
            }
        };

        const restorePreviousRoute = () => {
            if (location.pathname !== '/offline') return;
            const returnRoute = sessionStorage.getItem(RETURN_ROUTE_KEY) || '/login';
            sessionStorage.removeItem(RETURN_ROUTE_KEY);
            navigate(returnRoute, { replace: true });
        };

        window.addEventListener('offline', redirectOffline);
        window.addEventListener('online', restorePreviousRoute);

        if (navigator.onLine) restorePreviousRoute();
        else redirectOffline();

        return () => {
            window.removeEventListener('offline', redirectOffline);
            window.removeEventListener('online', restorePreviousRoute);
        };
    }, [location.hash, location.pathname, location.search, navigate]);

    return null;
};

export default ConnectivityRedirect;
